import useNaverADsScript, { NaverADsType } from "@repo/hooks/lib/useNaverADsScript";
import useOrderStatus from "@repo/shopify/hooks/useOrderStatus";
import useTracking from "@repo/shopify/hooks/useTracking";
import { OrderStatusTrans } from "@repo/shopify/src/utils/order";
import { transformDate } from "@repo/utils/src/number";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import Button from "@components/atoms/Button";
import PageTitle from "@components/atoms/PageTitle";
import Status from "@components/atoms/Status";

import Loading from "@molecules/Loading";

import OrderProductsInfo from "@organisms/Account/OrderDetail/OrderProductsInfo";

import useMeta from "@hooks/reducerHooks/useMeta";
import useUser from "@hooks/reducerHooks/useUser";

import { URLS } from "@const/urls";

import { getStatusColor } from "@utils/order";

// TODO: tsx로 변경
function OrderCompleted() {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const { setMetaTag } = useMeta();
  const { accessToken, fetchUser, updateOrders } = useUser();
  const { gtmPurchase } = useTracking();
  const { tryAppendNaverADsScript } = useNaverADsScript();
  const { t } = useTranslation();

  const [order, setOrder] = useState();

  useEffect(() => {
    setMetaTag({ title: `TUNE.KR - ORDER COMPLETED` });
    sessionStorage.removeItem("discount_code");

    void fetchUser({ variables: { customerAccessToken: accessToken } }).then(({ data }) => {
      const orderData = data?.customer.orders?.edges.find(
        ({ node }) => node.id.split("?")[0] === `gid://shopify/Order/${orderId}`,
      )?.node;

      if (!orderData) {
        navigate(URLS.NOT_FOUND);
      }

      setOrder(orderData);
      updateOrders(data?.customer.orders || []);
    });
  }, []);

  useEffect(() => {
    if (!orderId) {
      navigate(URLS.NOT_FOUND);
      return;
    }
    if (order) {
      gtmPurchase(order);
    }
  }, [order]);

  const { orderStatus } = useOrderStatus(order, true);

  const orderNumber = order?.name?.replace("#", "") || "";

  // 네이버 스크립트 삽입
  useEffect(() => {
    if (order) {
      const totalPrice = order.totalPrice?.amount ? parseInt(order.totalPrice.amount) : 0;
      if (totalPrice > 0) {
        const strTotalPrice = String(totalPrice);
        tryAppendNaverADsScript({ type: NaverADsType.PurchaseCompleted, value: strTotalPrice });
      }
    }
  }, [order]);

  return (
    <>
      {!order ? (
        <Loading description={t("account.order.wait_alert")} type="screen" />
      ) : (
        <>
          <PageTitle title={"THANK\nYOU!"} />
          <section className="tune-column-4 flex flex-col gap-10">
            <section className={"flex flex-col gap-2.5"}>
              <p className="text-sm text-tuneGrey-400">{order.processedAt ? transformDate(order.processedAt) : ""}</p>
              <Status
                orderName={orderNumber}
                statusColor={getStatusColor(orderStatus)}
                statusName={t(OrderStatusTrans[orderStatus])}
              />
            </section>
            <OrderProductsInfo order={order} />
            <Button
              className={"w-fit place-self-center"}
              onClick={() => {
                navigate(URLS.HOME);
              }}
            >
              Continue Shopping
            </Button>
          </section>
        </>
      )}
    </>
  );
}

export default OrderCompleted;
